import Player from 'youtube-player'
import getVideoId from 'get-video-id'

import EventBus from '@/js/util/EventBus'
import propsPlayer from '@/js/util/props/propsPlayer'

export default {
  props: {
    ...propsPlayer,
  },

  data() {
    return {
      toggle: false,
      player: undefined,
    }
  },

  computed: {
    determineModalUsage() {
      if (!this.useModal) {
        return false
      }

      return window.innerWidth >= 768
    },
  },

  created() {
    // if you are using this with the modal you
    // will have to pass in the prop useModal
    EventBus.$on(`toggle:${this.determineModalUsage ? 'modal' : 'video'}`, this.maybeToggle)
  },

  mounted() {
    const { id } = getVideoId(this.url)
    const options = {
      videoId: id,
    }

    this.player = new Player(this.$el, Object.assign(options, this.options))
    this.player.on('stateChange', this.handleStateChange)
  },

  methods: {
    maybeToggle(playerId) {
      if (playerId !== this.playerId) {
        return
      }
      this.toggle = !this.toggle
      this.player[this.toggle ? 'playVideo' : 'pauseVideo']()
    },

    handleStateChange({ data }) {
      const stateNames = { 2: 'paused' }[data]
      if (!stateNames) {
        return
      }
      this.player.pauseVideo()
    },
  },

  render: createElement => createElement('div'),
}



// WEBPACK FOOTER //
// ./src/js/components/player/PlayerYoutube.js